import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"
import {
    Backdrop,
    CircularProgress,
    Stack,
    Typography,
    useTheme
} from '@mui/material'

export default function PolygonStatsBackdrop({ open }) {
    const theme = useTheme()
    const { _ } = useLingui()

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: theme.zIndex.drawer + 10 }}
            open={open}
        >
            <Stack alignItems="center" spacing={2}>
                <CircularProgress size={80} color="inherit" />
                <Typography variant="body1">{_(msg`Loading data in progress...`)}</Typography>
            </Stack>
        </Backdrop>
    )
}
